import { getFCP } from 'web-vitals/base';

const onFirstContentfulPaint = response => {
  getFCP(fcp => response(fcp.value));
};

export default onFirstContentfulPaint;
